module.exports = __webpack_public_path__ + "img/daosanjiao.12c67e4c.png";